module.exports = __webpack_public_path__ + "img/Ekwateur_80X30.9dc54b54.png";